<template>
  <SelectBox
    v-model="choiceValue"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :options="options"
    full-width
    :validation-errors="validationErrors"
    @add-item="handleAddItem"
  ></SelectBox>
</template>

<script>
import { mapActions } from "vuex";

import SelectBox from "@/components/SelectBox.vue";
import useVuelidate from "@vuelidate/core";

export default {
  components: {
    SelectBox
  },
  props: {
    name: {
      type: String,
      default: "choice"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: null
    },
    validationErrors: {
      type: Object,
      default() {
        return {
          first: () => {}
        };
      }
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      options: []
    };
  },
  computed: {
    choiceValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        return this.$emit("update:modelValue", val);
      }
    }
  },
  mounted() {
    if (this.type) {
      this.fetchChoices(this.type).then(this.formatOptions);
    }
  },
  methods: {
    ...mapActions(["fetchChoices"]),
    formatOptions(response) {
      this.options = response.data.map((option) => {
        return {
          value: option,
          label: option
        };
      });
    },
    handleAddItem(e) {
      this.options = [...this.options, { value: e, label: e }];
      this.$emit("update:modelValue", e);
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep(.textfield-label) {
  width: 100%;
  margin-bottom: 0;
}
</style>
